<template>
  <div>
    <transition name="fade">
      <div :key="'compact_selector_dark'" class="pu_dark" v-if="$store.getters.modal.compactSelector"></div>
    </transition>
    <transition name="slide">
      <div :key="'compact_selector'" class="pu_bottom popup_click_hide" v-if="$store.getters.modal.compactSelector">
        <div class="pu_bottom_scroll">
          <div @click="close" class="pu_b_close"></div>
          <div class="pu_bottom_inner ">
            <div class="pu_select" style="display: block">
              <smooth-picker :change="dataChange" :data="data" :style="style" class="time_picker"
                             ref="smoothPicker"/>
            </div>
            <div class="pu_tovar_nav pu_tovar_nav_one">
              <div class="pu_tovar_nav_btn">
                <a @click="pick()" class="fbb_btn">
                  {{ text('product_options_choose') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import {SmoothPicker} from 'vue-smooth-picker'
  import 'vue-smooth-picker/dist/css/style.css'
  import {mapGetters} from 'vuex'
  import {SET_MODAL, SET_OPEN_LIST_MODIFIRE, SET_SELECTED_MODIFIRE} from '@/store/mutations.type'

  export default {
    name: 'CompactSelector',
    props: {
      setModalValue: {
        required: true,
        type: String
      }
    },
    components: {
      SmoothPicker
    },
    data() {
      return {
        style: {display: 'block'},

        data: [
          {
            currentIndex: 0,
            flex: 2,
            list: [],
            textAlign: 'center',
            className: 'row-group'
          },
          {
            currentIndex: 0,
            flex: 3,
            list: [],
            textAlign: 'center',
            className: 'item-group'
          }
        ],
        selectedItem: null
      }
    },
    computed: {
      getListModifire() {
        return this.$store.getters.getOpenListModifire
      }
    },

    mounted() {
      this.$store.subscribe(mutation => {
        if (mutation.type === SET_MODAL && mutation.payload.modal === 'compactSelector') {
          if (mutation.payload.status === true) {
            this.style.display = 'flex' // костыль для smooth-picker
          }
        }
      })
    },

    methods: {
      dataChange(gIndex, iIndex) {
        this.selectedItem = this.data[gIndex].list[iIndex]
      },

      pick() {
        if (this.selectedItem && this.selectedItem.id) {
          this.$store.commit(SET_SELECTED_MODIFIRE, this.selectedItem)
        }
        this.close()
      },

      close() {
        this.selectedItem = null
        this.data[1].currentIndex = 0
        this.$store.commit(SET_MODAL, {modal: 'compactSelector', status: false})
        this.$store.commit(SET_MODAL, {modal: this.setModalValue, status: true})
        this.$store.commit(SET_OPEN_LIST_MODIFIRE, null)
      }
    },

    watch: {
      getListModifire(val) {
        if (val && val.category && val.category.id) {
          this.data[0].list = [val.category.name]
          this.data[1].list = val.modifiers.map((item) => {
            // если в плагин передаём объект то value обязательно что бы вывести значение
            return {...item, value: item.name}
          })
          if (val.selectedModifier) {
            const indexCurrentMod = this.data[1].list.findIndex(x => x.id === val.selectedModifier.id)
            if (indexCurrentMod != -1) {
              this.selectedItem = this.data[1].list[indexCurrentMod]
              this.data[1].currentIndex = indexCurrentMod
            }
          } else {
            this.selectedItem = this.data[1].list[0]
          }
        }
      }
    }

  }
</script>
